import { createPortal } from "react-dom";
import classes from "./Modal.module.css";
import Utils from "../../Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export const ModalTitle = ({ children, onClose }) => {
  return (
    <div className={classes.header}>
      {children}
      {onClose && (
        <div
          style={{
            marginLeft: "1rem",
            cursor: "pointer",
            alignSelf: "flex-end",
          }}
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faXmark} />
        </div>
      )}
    </div>
  );
};

export const ModalBody = ({ children }) => {
  return <div className={classes.body}>{children}</div>;
};

export const ModalFooter = ({ children }) => {
  return <div className={classes.footer}>{children}</div>;
};

const container = typeof document !== 'undefined' && document.querySelector("#root");

const Modal = ({ title, children, onClose, className, style }) => {
  return createPortal(
    <>
      <div className={classes.backdrop}>
        <div
          className={Utils.getClasses(classes.modal, className ? className : "")}
          style={style}
        >
          {Boolean(title || onClose) && (
            <ModalTitle onClose={onClose}>{title}</ModalTitle>
          )}
          {children}
        </div>
      </div>
    </>,
    container
  );
};

export default Modal;
